class XeesterUser {
  id;
  name;
  username;
  email;
  block;
  registerDate;
  lastvisitDate;
  activation;
  params;
  groups;
  guest;
  lastResetTime;
  resetCount;
  requireReset;
  avatar;
  error = 401;
  firstLoad = true;
  crypt = "";
  //subscriptions= [{id: 34, avatar: "23422_5aaac85540e16.png", username: "ngba3287"}]
  subscriptions = [];

  static from(json) {
    let user = new XeesterUser();
    Object.assign(user, json);
    if (json.error !== 401) {
      user.error = null;
    }
    user.firstLoad = false;
    return user;
  }
}

export default XeesterUser;
